module.exports = __webpack_public_path__ + "static/media/logoWhite.02afc328.svg";